import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Shield, Layers, Globe, ArrowRight } from 'lucide-react'

const capabilities = [
  {
    icon: Layers,
    title: 'Integrated Value Chain',
    description: 'Mine to market control. Quality, traceability and reliable delivery worldwide.',
  },
  {
    icon: Shield,
    title: 'Responsible Operations',
    description: 'Environmental excellence and sustainable practices across our operations.',
  },
  {
    icon: Globe,
    title: 'Strategic Global Position',
    description: 'The only producer outside China. Serving critical industries globally.',
  },
]

export default function Features() {
  return (
    <section id="features" className="relative pt-28 md:pt-32 pb-24 md:pb-32 bg-accent overflow-hidden">
      <div className="container relative z-10">
        <div className="max-w-3xl mx-auto mb-20 text-center">
          <h2 className="text-sm font-semibold text-white/70 uppercase tracking-[0.2em] mb-4">Strategic Capabilities</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white tracking-tight leading-[1.1]">
            Integrated. Responsible. Essential.
          </h3>
        </div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {capabilities.map((capability, i) => (
            <motion.div
              key={capability.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -4 }}
              className="group relative text-center p-8 md:p-10 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:bg-white/10 hover:border-white/20 hover:shadow-xl hover:shadow-black/10"
            >
              <div className="flex flex-col items-center gap-6 mb-6">
                <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-white/15 text-white group-hover:bg-white/25 group-hover:scale-110 transition-all duration-300">
                  <capability.icon className="h-8 w-8" strokeWidth={1.5} />
                </div>
                <h4 className="text-xl font-bold font-heading text-white tracking-tight">{capability.title}</h4>
              </div>
              <p className="text-white/80 leading-relaxed text-[15px]">{capability.description}</p>
            </motion.div>
          ))}
        </div>
        <div className="max-w-4xl mx-auto mt-16 text-center">
          <p className="text-white/90 leading-relaxed text-lg mb-6">
            Lynas Rare Earths is the world&apos;s only significant producer of separated rare earth materials outside China. Headquartered in Australia, we operate an integrated supply chain from our high-grade Mt Weld mine through processing at Kalgoorlie and our advanced materials plant in Malaysia.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/strategy"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white text-accent font-semibold hover:bg-white/95 transition-colors group"
            >
              Towards 2030 Strategy
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-white/40 text-white font-semibold hover:bg-white/10 transition-colors group"
            >
              Our Story
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
